export default __webpack_public_path__ + "static/media/skill_matlab.2b608e94.png";